const messages = {
    menuTitle: 'Kalkulacje',
    pageTitle: 'Kalkulacje',
    units: {
        mm: 'mm',
        min: 'min',
        pln: 'zł'
    },
    list: {
        menuTitle: 'Lista kalkulacji',
        pageTitle: 'Kalkulacje / Lista kalkulacji',
        placeholder: 'Widok w przygotowaniu (Etap 1: routing i wrapper).',
        actions: {
            create: 'Nowa kalkulacja',
            openDisabled: 'Szczegóły w przygotowaniu'
        },
        filters: {
            status: 'Status',
            search: 'Szukaj po numerze, nazwie',
            customerName: 'Szukaj po kliencie',
            createdBy: 'Tworzący',
            createdFrom: 'Kalkulacja utworzona od',
            createdTo: 'Kalkulacja utworzona do'
        },
        table: {
            headers: {
                number: 'Numer kalkulacji',
                name: 'Nazwa kalkulacji',
                customer: 'Klient',
                status: 'Status',
                createdAt: 'Data utworzenia',
                createdBy: 'Utworzone przez',
                actions: 'Akcje'
            }
        },
        tooltips: {
            priceOffer: 'Generuj ofertę cenową',
            createOrder: 'Złóż zamówienie',
            copy: 'Skopiuj kalkulację',
            open: 'Otwórz',
            delete: 'Usuń'
        },
        dialogs: {
            createOrder: {
                title: 'Składanie zamówienia z kalkulacji',
                content: 'Czy na pewno chcesz utworzyć zamówienie?',
                confirm: 'Zatwierdź'
            },
            delete: {
                title: 'Usuwanie kalkulacji',
                content: 'Czy na pewno chcesz usunąć kalkulację?',
                confirm: 'Usuń'
            },
            copy: {
                title: 'Kopiowanie kalkulacji',
                content: 'Czy na pewno chcesz skopiować kalkulację?',
                confirm: 'Potwierdź'
            }
        },
        notifications: {
            fetchCalculationsError: 'Pobranie listy kalkulacji nie powiodło się.',
            fetchStatusesError: 'Pobranie listy statusów nie powiodło się.',
            createCalculationError: 'Utworzenie kalkulacji nie powiodło się.',
            createOrderSuccess: 'Utworzono nowe zamówienie.',
            updateCalculationError: 'Edycja kalkulacji nie powiodła się.',
            deleteCalculationError: 'Usunięcie kalkulacji nie powiodło się.',
            copyCalculationError: 'Skopiowanie kalkulacji nie powiodło się.',
            printPriceOfferError: 'Wygenerowanie oferty cenowej nie powiodło się.'
        },
        usersSearch: {
            searching: 'Trwa wyszukiwanie...',
            emptyPrompt: 'Wpisz treść aby odnaleźć użytkownika.',
            noResults: 'Nie znaleziono'
        }
    },
    details: {
        pageTitle: 'Kalkulacje / Kalkulacja',
        actions: {
            backToList: 'Powrót do listy',
            prevStep: 'Poprzedni krok',
            nextStep: 'Następny krok'
        },
        sentry: {
            backToList: 'Back to calculations list',
            prevStep: 'Previous step',
            nextStep: 'Next step',
            summaryPrevStep: 'Poprzedni krok'
        },
        sections: {
            clientAndProducts: 'Klient i produkty'
        },
        steps: {
            clientAndProducts: 'Klient i produkty',
            impositions: 'Montaże',
            summary: 'Podsumowanie'
        },
        summary: {
            sections: {
                customer: 'Klient',
                pricing: 'Wycena',
                products: 'Produkty',
                impositions: 'Montaże'
            },
            fields: {
                nip: 'NIP',
                basePrice: 'Cena bazowa',
                traderMargin: 'Narzut handlowca',
                traderMarginAmount: 'Narzut (zł)',
                offerPrice: 'Cena ofertowa',
                assemblyPaper: 'Papier do montażu'
            },
            notifications: {
                printReportError: 'Wygenerowanie raportu nie powiodło się.',
                updateTraderMarginError: 'Aktualizacja marży nie powiodła się.',
                fetchPriceComponentsError: 'Pobranie składników cenowych kalkulacji nie powiodło się.',
                updatePriceComponentsError: 'Aktualizacja składników cenowych kalkulacji nie powiodła się.',
                invalidCalculation: 'Proszę poprawnie rozpisać kalkulację.',
                confirmSuccess: 'Zatwierdzono kalkulację.'
            },
            actions: {
                change: 'Zmień',
                editPrices: 'Edycja cen',
                printReport: 'Generuj raport',
                confirm: 'Zatwierdź'
            },
            tooltips: {
                actionNotAvailable: 'Akcja tymczasowo niedostępna'
            },
            sentry: {
                changeTraderMargin: 'Change trader margin',
                editPrices: 'Edit prices',
                printReport: 'Print report',
                confirm: 'Confirm calculation'
            },
            traderMarginDialog: {
                title: 'Narzut handlowca',
                fields: {
                    minimalValue: 'Minimalny narzut',
                    value: 'Narzut'
                },
                validation: {
                    invalidValue: 'Proszę podać prawidłową wartość.',
                    minValue: 'Minimalna marża wynosi {min}%.'
                }
            },
            priceMaterialsDialog: {
                title: 'Edycja cen',
                table: {
                    headers: {
                        imposition: 'Montaż',
                        component: 'Składnik',
                        name: 'Nazwa',
                        amount: 'Ilość',
                        piecePrice: 'Cena jednostkowa',
                        totalPrice: 'Wartość'
                    }
                }
            },
            confirmRemoveEmptyImpositions: {
                title: 'Po zatwierdzeniu kalkulacji następujące puste montaże zostaną usunięte:',
                item: 'Montaż {number}'
            },
            table: {
                headers: {
                    productType: 'Rodzaj produktu',
                    productName: 'Nazwa produktu',
                    amount: 'Nakład'
                }
            }
        },
        impositions: {
            tasks: {
                sharedLabel: '(łączone)',
                actions: {
                    addDieCutter: 'Dodaj wykrojnik',
                    configureAssemblyPaper: 'Papier do montażu'
                },
                sentry: {
                    addMaterial: 'Dodawanie materiału'
                },
                dialogs: {
                    materials: {
                        titlePrefix: 'Materiały procesu'
                    },
                    slicingFormats: {
                        titlePrefix: 'Formaty na wyjściu'
                    },
                    paperConfiguration: {
                        title: 'Papier do montażu'
                    }
                },
                tableHeaders: {
                    productComponents: {
                        componentName: 'Nazwa komponentu',
                        outputFormatA: 'Format A wyjścia',
                        outputFormatB: 'Format B wyjścia'
                    },
                    materials: {
                        name: 'Nazwa',
                        materialIndex: 'Indeks materiałowy',
                        usedPercent: 'Pokrycie (%)',
                        unit: 'Jednostka'
                    }
                },
                placeholders: {
                    noMaterials: 'Nie dodano materiałów',
                    notApplicable: 'n/d',
                    noPrint: 'bez zadruku'
                },
                autocomplete: {
                    noResults: 'Nie znaleziono',
                    noData: 'Brak danych...'
                },
                hints: {
                    allowedRange: 'Dopuszczalny zakres {range}',
                    allowedRangeOr: 'Dopuszczalny zakres {range1} lub {range2}'
                },
                warnings: {
                    tooLargeFormatPrefix: 'Uwaga!',
                    tooLargeFormatContent: 'Zbyt duży format, dodaj proces',
                    tooLargeFormatProcess: 'krojenie',
                    tooLargeFormatBeforeProcess: 'przed procesem'
                },
                colorSettings: {
                    title: 'Ustawienia kolorystyki {side}',
                    noColors: 'Nie dodano kolorów',
                    headers: {
                        type: 'Typ',
                        color: 'Kolor',
                        coverage: 'Pokrycie (%)',
                        description: 'Opis',
                        pmsType: 'Rodzaj'
                    },
                    notifications: {
                        invalidPms: 'Uzupełnij rodzaj i opis dla kolorów PMS.'
                    }
                },
                fields: {
                    machine: 'Maszyna',
                    paperType: 'Rodzaj papieru',
                    paperName: 'Nazwa papieru',
                    netAmount: 'Nakład netto',
                    bruttoAmount: 'Nakład brutto',
                    productsInSetAmount: 'Ilość produktów w komplecie',
                    duration: 'Czas',
                    wasteAmount: 'Straty',
                    wastePercent: 'Straty',
                    certificate: 'Certyfikat',
                    sendPaperWaste: 'Wysyłka makulatury',
                    paperCertificateName: 'Nazwa certyfikatu',
                    extraWasteAmount: 'Dodatkowe straty na zepsucie',
                    formatA: 'Format A',
                    formatB: 'Format B',
                    paperFormatA: 'Format papieru A',
                    paperFormatB: 'Format papieru B',
                    outputFormatA: 'Format A na wyjściu',
                    outputFormatB: 'Format B na wyjściu',
                    rollWidth: 'Szerokość rolki',
                    rollCutoff: 'Odcięcie rolki',
                    impositionAmount: 'Ilość montaży',
                    service: 'Usługa',
                    printMethod: 'Sposób druku',
                    plateType: 'Rodzaj płyty',
                    colorsA: 'Kolorystyka A',
                    colorsB: 'Kolorystyka B',
                    colorTemplate: 'Wzór kolorystyczny',
                    rubber: 'Guma',
                    rubberNumber: 'Numer gumy',
                    rubberFromImposition: 'Wybierz gumę z montażu',
                    materials: 'Materiały',
                    dieCutter: 'Wykrojnik',
                    dieCutterNumber: 'Numer Wykrojnika',
                    dieCutterPrice: 'Cena wykrojnika',
                    partAmountAfterCutting: 'Ilość użytków po krojeniu',
                    description: 'Uwagi do procesu'
                },
                errors: {
                    productsInSetAmount: 'Proszę podać liczbę całkowitą większą od 0.',
                    paperRequired: 'Proszę wybrać papier.',
                    paperDescriptionTooLong: 'Nazwa papieru może mieć maksymalnie 256 znaków.',
                    paperCertificateRequired: 'Proszę wybrać certyfikat.'
                }
            },
            sections: {
                components: 'Komponenty',
                processes: 'Procesy'
            },
            dialogs: {
                manageComponents: {
                    title: 'Edycja zbiorcza komponentów'
                },
                addComponents: {
                    title: 'Wybierz komponenty dla montażu'
                },
                addImposition: {
                    title: 'Wybierz komponenty dla nowego montażu'
                },
                copyParameters: {
                    title: 'Wybierz montaż źródłowy do skopiowania'
                },
                editComponent: {
                    titlePrefix: 'Edycja komponentu'
                }
            },
            actions: {
                bulkEdit: 'Edycja zbiorcza',
                removeImposition: 'Usuń montaż',
                copyParameters: 'Kopiuj parametry',
                addImposition: 'Dodaj montaż',
                addNewImposition: 'Dodaj nowy',
                copy: 'Kopiuj',
                editComponent: 'Edytuj komponent',
                detachComponent: 'Odłącz komponent',
                addComponent: 'Dodaj komponent'
            },
            confirmations: {
                removeImposition: {
                    title: 'Usuwanie montażu',
                    content: 'Czy na pewno chcesz usunąć montaż? Tej operacji nie można cofnąć.'
                },
                detachComponent: {
                    titlePrefix: 'Odłączanie komponentu',
                    content: 'Czy na pewno chcesz odłączyć komponent?'
                },
                removeEmptyImpositions: {
                    title: 'Znaleziono puste montaże',
                    content: 'Czy chcesz automatycznie usunąć puste montaże?'
                }
            },
            gates: {
                unassignedComponents: {
                    title: 'Nieprzypisane komponenty',
                    description: 'Brak przypisanego produktu/komponentu do montażu'
                },
                invalidData: {
                    title: 'Nieprawidłowe dane',
                    description: 'Format komponentu jest mniejszy niż format arkusza'
                }
            },
            packing: {
                actions: {
                    addPackage: 'Dodaj pakowanie',
                    edit: 'Edycja',
                    products: 'Produkty'
                },
                sentry: {
                    addPackage: 'Dodaj pakowanie',
                    editPackage: 'Edycja pakowania',
                    confirmRemovePackage: 'Potwierdzenie usunięcia pakowania',
                    addProducts: 'Dodaj produkty',
                    editProductInPackage: 'Edycja produktu w pakowaniu',
                    confirmRemoveProduct: 'Potwierdzenie usunięcia produktu z pakowania'
                },
                confirmations: {
                    removePackage: {
                        title: 'Usuwanie pakowania',
                        content: 'Czy na pewno chcesz usunąć pakowanie?'
                    },
                    removeProduct: {
                        title: 'Usuwanie produktu z pakowania',
                        content: 'Czy na pewno chcesz usunąć produkt?'
                    }
                },
                tableHeaders: {
                    boxType: 'Sposób pakowania',
                    packageType: 'Rodzaj opakowania',
                    amount: 'Ilość',
                    maxWeightCapacity: 'Nośność',
                    product: 'Produkt',
                    productAmount: 'Nakład',
                    weight: 'Waga'
                },
                dimensions: {
                    length: 'D',
                    width: 'SZ',
                    height: 'W'
                },
                dialogs: {
                    package: {
                        titleAdd: 'Dodaj pakowanie',
                        titleEdit: 'Edycja pakowania',
                        fields: {
                            boxType: 'Sposób pakowania',
                            packageType: 'Opakowanie',
                            length: 'Długość',
                            width: 'Szerokość',
                            height: 'Wysokość',
                            setManuallyAmount: 'Ręczna edycja ilości opakowań',
                            packageAmount: 'Ilość opakowań'
                        },
                        errors: {
                            boxTypeRequired: 'Proszę podać sposób pakowania.',
                            packageTypeRequired: 'Proszę podać rodzaj opakowania.',
                            lengthRequired: 'Proszę podać długość.',
                            widthRequired: 'Proszę podać szerokość.',
                            heightRequired: 'Proszę podać wysokość.',
                            packageAmountRequired: 'Liczba opakowań jest wymagana',
                            packageAmountPositiveInteger: 'Proszę podać całkowitą dodatnią liczbę opakowań'
                        }
                    },
                    ware: {
                        titleAdd: 'Dodaj towar',
                        titleEdit: 'Edycja towaru',
                        fields: {
                            product: 'Produkt',
                            amount: 'Nakład'
                        },
                        hints: {
                            productFullyAssigned: 'Produkt jest w pełni rozpisany.'
                        },
                        errors: {
                            productRequired: 'Proszę wybrać produkt.',
                            productAlreadyInPackage: 'Wybrany produkt istnieje już w tym pakowaniu.',
                            amountRequired: 'Proszę podać nakład.',
                            amountRange: 'Proszę podać wartość z zakresu 1-{max}'
                        }
                    }
                }
            },
            sending: {
                dialog: {
                    title: 'Edycja rodzaju wysyłki',
                    fields: {
                        transport: 'Transport',
                        distance: 'Dystans',
                        cost: 'Koszt'
                    },
                    actions: {
                        calculateCost: 'Oblicz koszt wysyłki'
                    },
                    errors: {
                        maxTwoDecimals: 'Maksymalnie 2 cyfry po przecinku'
                    }
                }
            },
            sentry: {
                manageComponents: 'Bulk edit components',
                removeImposition: 'Remove imposition',
                copyParameters: 'Copy imposition parameters',
                addImposition: 'Add imposition',
                addComponents: 'Add components to imposition',
                colorSettings: {
                    addColor: 'Add print color',
                    removeColor: 'Remove print color',
                    cancel: 'Cancel color settings',
                    close: 'Close color settings',
                    save: 'Save color settings'
                }
            },
            fields: {
                parts: 'Ilość użytków'
            },
            tableHeaders: {
                customName: 'Nazwa własna',
                productName: 'Nazwa produktu',
                component: 'Komponent',
                parts: 'Ilość użytków',
                amount: 'Nakład',
                imposition: 'Montaż'
            },
            impositionNumber: 'Montaż {number}'
        },
        fields: {
            name: 'Nazwa kalkulacji',
            customer: 'Klient'
        },
        customerSearch: {
            emptyPrompt: 'Wpisz treść aby odnaleźć klienta.',
            minLength: 'Wpisz przynajmniej {min} znaki.',
            searching: 'Trwa wyszukiwanie...',
            noResults: 'Nie znaleziono'
        },
        placeholders: {
            stepInProgress: 'Ten krok jest w przygotowaniu.'
        },
        validation: {
            nameRequired: 'Proszę podać nazwę.',
            customerRequired: 'Proszę wybrać klienta.'
        },
        products: {
            title: 'Produkty',
            noProducts: 'Nie wybrano produktów do kalkulacji.',
            actions: {
                addProduct: 'Dodaj produkt'
            },
            sentry: {
                openProduct: 'Otwórz produkt',
                editProduct: 'Edytuj produkt',
                copyProduct: 'Kopiuj produkt',
                deleteProduct: 'Usuń'
            },
            tooltips: {
                open: 'Otwórz',
                edit: 'Edytuj',
                copy: 'Kopiuj',
                delete: 'Usuń'
            },
            dialogs: {
                delete: {
                    title: 'Usuwanie produktu',
                    content: 'Czy na pewno chcesz usunąć produkt? Tej operacji nie można cofnąć.',
                    confirm: 'Usuń'
                }
            },
            notifications: {
                deleteBlockedInImposition: 'Nie można usunąć produktu, który jest przydzielony do montażu.',
                deleteBlockedInPacking: 'Nie można usunąć produktu, który jest przydzielony do pakowania.'
            },
            tableHeaders: {
                productType: 'Rodzaj produktu',
                name: 'Nazwa produktu',
                formatA: 'Szerokość',
                formatB: 'Wysokość',
                amount: 'Nakład',
                isInImposition: 'Czy przydzielony?',
                actions: 'Akcje'
            }
        },
        notifications: {
            fetchCalculationError: 'Pobranie kalkulacji nie powiodło się.',
            copyImpositionParametersError: 'Kopiowanie parametrów impozycji nie powiodło się.',
            fetchCalculationValidationError: 'Pobranie walidacji kalkulacji nie powiodło się.',
            fetchImpositionTaskError: 'Pobranie szczegółów procesu nie powiodło się.',
            updateImpositionTaskError: 'Zapis procesu nie powiódł się.',
            fetchImpositionError: 'Pobranie szczegółów montażu nie powiodło się.',
            updateImpositionError: 'Zapis montażu nie powiódł się.',
            fetchPrintColoursError: 'Pobranie kolorów druku nie powiodło się.',
            fetchColourTemplatesError: 'Pobranie wzorów kolorystycznych nie powiodło się.',
            fetchPapersError: 'Pobranie listy papierów nie powiodło się.',
            fetchPaperCertificatesError: 'Pobranie listy certyfikatów nie powiodło się.',
            fetchMachinesError: 'Pobranie listy maszyn nie powiodło się.',
            updatePaperConfigurationError: 'Zapis konfiguracji papieru do montażu nie powiódł się.'
        }
    },
    product: {
        addPageTitle: 'Kalkulacje / Kalkulacja / Dodaj produkt',
        editPageTitle: 'Kalkulacje / Kalkulacja / Produkt',
        units: {
            pcs: 'szt.'
        },
        sections: {
            parameters: 'Parametry produktu',
            components: 'Komponenty',
            productionProperties: 'Cechy produkcyjne:'
        },
        fields: {
            productType: 'Rodzaj produktu',
            name: 'Nazwa produktu',
            formatA: 'Szerokość produktu',
            formatB: 'Wysokość produktu',
            amount: 'Nakład',
            isSignal: 'Sygnalne produktu',
            signalAmount: 'Ilość'
        },
        placeholders: {
            noComponents: 'Produkt nie posiada przypisanych komponentów.',
            noProductionProperties: 'Brak przypisanych cech produkcyjnych.'
        },
        validation: {
            productTypeRequired: 'Proszę podać rodzaj produktu.',
            nameRequired: 'Proszę podać nazwę produktu.',
            nameUnique: 'Kalkulacja zawiera już produkt o takiej nazwie.',
            amountRequired: 'Proszę podać nakład.',
            signalAmountRequired: 'Ilość musi być większa od 0.',
            productionPropertyRequired: 'Proszę podać wartość.',
            productsInSetCombination: 'Nie można łączyć kompletowanego produktu z innymi.'
        },
        notifications: {
            fetchProductTypesError: 'Pobranie listy produktów nie powiodło się.',
            fetchProductTypeError: 'Pobranie komponentów produktu nie powiodło się.'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
